"use client";

import { useEffect, useRef, useState } from "react";
import {
  useLocationContext,
  type HeroLocation,
} from "@/components/home/context/LocationContext";
import { fetchRequestGeo } from "@/lib/request-geo-client";

async function resolveInitialLocation(): Promise<HeroLocation | null> {
  const geo = await fetchRequestGeo();
  if (!geo) return null;
  return {
    lat: geo.latitude,
    lng: geo.longitude,
    city: geo.city || undefined,
    state: geo.state || undefined,
    postalCode: geo.postalCode || undefined,
  };
}

export function useVisitorLocation() {
  const { location, setLocation } = useLocationContext();
  const [settled, setSettled] = useState(location !== null);
  const openedWithLocationRef = useRef(location !== null);
  const latestLocationRef = useRef(location);

  useEffect(() => {
    latestLocationRef.current = location;
  }, [location]);

  useEffect(() => {
    if (openedWithLocationRef.current) return;
    let superseded = false;
    void resolveInitialLocation().then((initial) => {
      if (initial && !superseded && latestLocationRef.current === null) {
        setLocation(initial);
      }
      setSettled(true);
    });
    return () => {
      superseded = true;
    };
  }, [setLocation]);

  return { location, isSeeding: location === null && !settled };
}
